import { c as _c } from "react/compiler-runtime";
import BackgroundGrid from "@assets/illustrations/background-grid.svg?react";
import { MapListTwoToneIcon } from "@components/common/icons";
import { ProjectLocationEditor } from "@components/project-location-editor/project-location-editor";
import { Button, Text } from "@flat-ui";
import { Stack } from "@mui-wrapper";
/**
 * Component to display when a project does not have a location and
 * thus it cannot be displayed on the project map.
 */
export function ProjectMapEmptyPage(t0) {
  const $ = _c(18);
  const {
    project,
    isDialogOpen,
    openDialog,
    closeDialog,
    isInteractive: t1
  } = t0;
  const isInteractive = t1 === undefined ? true : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      textAlign: "center",
      alignItems: "center",
      padding: "20px"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      alignItems: "center",
      justifyContent: "center"
    };
    t4 = <BackgroundGrid />;
    $[1] = t3;
    $[2] = t4;
  } else {
    t3 = $[1];
    t4 = $[2];
  }
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Stack sx={t3}>{t4}<MapListTwoToneIcon sx={{
        height: "44px",
        width: "44px",
        position: "absolute"
      }} /></Stack>;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Text variant="heading16" sx={{
      color: "text.secondary",
      marginTop: "8px"
    }}>No coordinates set for this project</Text>;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  const t7 = isInteractive ? "visible" : "hidden";
  let t8;
  if ($[5] !== t7) {
    t8 = {
      marginTop: "12px",
      visibility: t7
    };
    $[5] = t7;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  let t9;
  if ($[7] !== openDialog || $[8] !== t8) {
    t9 = <Button variant="ghost" onClick={openDialog} sx={t8}>Add coordinates</Button>;
    $[7] = openDialog;
    $[8] = t8;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== closeDialog || $[11] !== isDialogOpen || $[12] !== isInteractive || $[13] !== project) {
    t10 = isInteractive && isDialogOpen && <ProjectLocationEditor project={project} onClose={closeDialog} />;
    $[10] = closeDialog;
    $[11] = isDialogOpen;
    $[12] = isInteractive;
    $[13] = project;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t10 || $[16] !== t9) {
    t11 = <Stack sx={t2}>{t5}{t6}{t9}{t10}</Stack>;
    $[15] = t10;
    $[16] = t9;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  return t11;
}